import { type ReactNode } from 'react';
import type React from 'react';

export interface PageWithNavFooterProps {
  footer?: ReactNode;
  heading?: string | React.ComponentPropsWithoutRef<'h1'>;
  children?: ReactNode;
}

export default function PageWithNavFooter({ heading, children, footer }: PageWithNavFooterProps) {
  return (
    <div className="flex justify-center">
      <div className="max-w-[600px] grow sm:pt-[72px] pt-[40px] px-16">
        {typeof heading === 'string' ? (
          <h1 className="mb-16">{heading}</h1>
        ) : (
          heading && (
            <h1 className="mb-16" {...heading}>
              {heading.children}
            </h1>
          )
        )}

        <div className="mb-64">{children}</div>
        {footer && <div className="max-w-[600px] w-full flex justify-between items-center py-24">{footer}</div>}
      </div>
    </div>
  );
}
